import { Component, Input } from '@angular/core';
import { CheckoutAreaSettings, GlobalButtonDesign, GLOBAL_BUTTON_DESIGN_DEFAULT } from '../widget-preview.types';

interface ResolvedButton {
  backgroundColor: string;
  textColor: string;
  hoverColor: string;
  cornerRadius: number;
}

@Component({
  selector: 'checkout-area-preview',
  templateUrl: './checkout-area-preview.component.html',
  styleUrls: ['./checkout-area-preview.component.scss'],
  standalone: false,
})
export class CheckoutAreaPreviewComponent {
  @Input() settings!: CheckoutAreaSettings;
  @Input() globalButtonDesign: GlobalButtonDesign = GLOBAL_BUTTON_DESIGN_DEFAULT;

  get resolvedCheckout(): ResolvedButton {
    return this.resolveButton(this.settings.checkoutButton.design);
  }

  get resolvedViewCart(): ResolvedButton {
    return this.resolveButton(this.settings.viewCartButton.design);
  }

  get checkoutDisabledLook(): boolean {
    return this.settings.terms.enabled;
  }

  onPrimaryHoverEnter(event: MouseEvent): void {
    if (this.checkoutDisabledLook) return;
    (event.currentTarget as HTMLElement).style.backgroundColor = this.resolvedCheckout.hoverColor;
  }

  onPrimaryHoverLeave(event: MouseEvent): void {
    if (this.checkoutDisabledLook) return;
    (event.currentTarget as HTMLElement).style.backgroundColor = this.resolvedCheckout.backgroundColor;
  }

  onViewCartHoverEnter(event: MouseEvent): void {
    (event.currentTarget as HTMLElement).style.backgroundColor = this.resolvedViewCart.hoverColor;
  }

  onViewCartHoverLeave(event: MouseEvent): void {
    (event.currentTarget as HTMLElement).style.backgroundColor = this.resolvedViewCart.backgroundColor;
  }

  private resolveButton(d: CheckoutAreaSettings['checkoutButton']['design']): ResolvedButton {
    const g = this.globalButtonDesign;
    return {
      backgroundColor: d.backgroundColor ?? g.backgroundColor,
      textColor: d.textColor ?? g.textColor,
      hoverColor: d.hoverColor ?? g.hoverTextColor,
      cornerRadius: d.cornerRadius ?? g.cornerRadius,
    };
  }
}
